import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/brand/brand/apps/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import ComponentLayout from '../../../src/layouts/component-layout';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const DoDontContainer = makeShortcode("DoDontContainer");
const Do = makeShortcode("Do");
const Caption = makeShortcode("Caption");
const Dont = makeShortcode("Dont");
const layoutProps = {
  _frontmatter
};
const MDXLayout = ComponentLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h2>{`Usage`}</h2>
    <p>{`Use an image to display a graphical representation, such as a photograph or a visual illustration, on a web page. Use it in combination with text to provide context or additional information.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/912236/3ffc80cb-4d7d-4ef4-b66f-10e902d8f17c" alt="" />
    <Caption mdxType="Caption">
      Use an image to display a photograph in combination with descriptive text
      to provide context.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/912236/6f29d849-9379-4327-a4aa-e1233e19861b" alt="" />
    <Caption mdxType="Caption">Don't use an icon as an image or illustration.</Caption>
  </Dont>
    </DoDontContainer>
    <h2>{`Options`}</h2>
    <h3>{`Size`}</h3>
    <p>{`Choose the appropriate dimensions for the image to fit the desired layout using the `}<inlineCode parentName="p">{`width/height`}</inlineCode>{` or the `}<inlineCode parentName="p">{`aspect-ratio`}</inlineCode>{` properties. Avoid using images that are too large or too small for their intended display. When using images in a list, make sure they are all the same size to achieve a visually balanced layout.`}</p>
    <DoDontContainer stacked mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/912236/7e9cf19c-1545-4b47-9ac8-0442050eb509" alt="" />
    <Caption mdxType="Caption">
      In a list or group, use images of the same size and aspect ratio.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/912236/6efc49d3-f982-4f9f-9951-413a05f329cc" alt="" />
    <Caption mdxType="Caption">Don't use images of different sizes in the same section.</Caption>
  </Dont>
    </DoDontContainer>
    <h2>{`Accessibility`}</h2>
    <p>{`Use the `}<inlineCode parentName="p">{`alt`}</inlineCode>{` attribute to provide alternative text that is displayed if the image cannot be loaded or for accessibility purposes. It is important to include descriptive alternative text that conveys the meaning or content of the image. For more info, see `}<a parentName="p" {...{
        "href": "https://primer.style/design/guides/accessibility/alternative-text-for-images"
      }}>{`alternative text for images`}</a>{`.`}</p>
    <p>{`Optimize your images to reduce file size without compromising quality. Smaller file sizes improve page loading speed.`}</p>
    <h2>{`Related components`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/brand/components/Card"
        }}>{`Card`}</a>{`: to display navigational related content with higher visual weight.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/brand/components/River"
        }}>{`River`}</a>{`: To display a list of content items with a visual asset.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/brand/components/Avatar"
        }}>{`Avatar`}</a>{`: Use avatar to display a thumbnail representation of a person.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      